interface GetPercentageDiscountPriceProps {
  price: number;
  percentageDiscount: number;
}

const getPercentageDiscountPrice = ({
  price,
  percentageDiscount,
}: GetPercentageDiscountPriceProps) => {
  let newPrice = price;
  if (percentageDiscount) {
    newPrice = price - price * (percentageDiscount / 100);
  }
  return parseFloat(newPrice.toString()).toFixed(2);
};

export default getPercentageDiscountPrice;
